/**
 * Print-oriented design tokens for generated PDFs.
 *
 * The on-screen chat is a dark glass UI; a printed transcript is the opposite,
 * so these are tuned for ink on white rather than lifted from the page styles.
 */

export type Rgb = [number, number, number];

export const PDF_MARGIN = {
  top: 54,
  right: 48,
  bottom: 56,
  left: 48,
};

export const PDF_COLOR: Record<string, Rgb> = {
  ink: [23, 32, 46],
  body: [45, 55, 72],
  muted: [113, 128, 150],
  faint: [160, 174, 192],
  rule: [226, 232, 240],
  accent: [5, 150, 105],
  link: [13, 110, 100],
  codeBg: [244, 246, 248],
  codeInk: [51, 65, 85],
  tableHeadBg: [241, 245, 249],
  userRule: [148, 163, 184],
  assistantRule: [16, 185, 129],
  chipBg: [241, 245, 249],
};

export const PDF_FONT = {
  body: 10.5,
  lineHeight: 1.45,
  small: 9,
  tiny: 8,
  code: 9,
  codeLineHeight: 1.4,
  roleLabel: 8.5,
  title: 16,
  wordmark: 15,
  h1: 15,
  h2: 13,
  h3: 11.5,
  h4: 10.5,
};

export const PDF_SPACE = {
  paragraph: 7,
  heading: 11,
  headingAfter: 5,
  block: 10,
  message: 18,
  listItem: 3,
  listIndent: 16,
  quoteIndent: 14,
  ruleGap: 10,
  cellPadX: 6,
  cellPadY: 5,
  codePadX: 8,
  codePadY: 6,
};

/** Heading depth (1-6) to point size. */
export const headingSize = (depth: number): number => {
  if (depth <= 1) return PDF_FONT.h1;
  if (depth === 2) return PDF_FONT.h2;
  if (depth === 3) return PDF_FONT.h3;
  return PDF_FONT.h4;
};
